import React from 'react'
import { GridItem } from '@which/seatbelt'

import type {
  Callout as CalloutType,
  SubVerticalCrTopicPageQuery,
} from '../../../../generated/frontend'
import { Breadcrumb } from '../../../../shared/components/Breadcrumb/Breadcrumb'
import { Callout } from '../../../../shared/components/Callout/Callout'
import { LocalFooter } from '../../../../shared/components/LocalFooter/LocalFooter'
import { TaxonomyConversionBanner } from '../../../../shared/components/TaxonomyConversionBanner/TaxonomyConversionBanner'
import { CRCategories } from '../../components/CRCategories'
import { SubVerticalHeader } from '../../components/SubVerticalHeader'
import { SuperCategoryJumpLinks } from '../../components/SuperCategoryJumpLinks'

export const getSubVerticalCRTopicComponents = (
  data: SubVerticalCrTopicPageQuery['subVerticalPage']
) => {
  const {
    header,
    callout,
    crCategories: {
      jumpLinks: { links: crJumpLinks },
      sections: crSections,
    },
    breadcrumb,
    taxonomyConversionBanner,
    consumerRightsFooter,
  } = data

  return {
    SubVerticalHeader: () => (
      <GridItem span={{ medium: 10, large: 10 }} columnStart={{ medium: 2, large: 2 }}>
        <SubVerticalHeader {...header} />
      </GridItem>
    ),
    SubVerticalJumpLinks: () => (
      <GridItem span={{ medium: 10, large: 10 }} columnStart={{ medium: 2, large: 2 }}>
        <SuperCategoryJumpLinks links={crJumpLinks} />
      </GridItem>
    ),
    Breadcrumb: () => <Breadcrumb {...breadcrumb} />,
    Callout: () => (
      <GridItem span={{ large: 10 }} columnStart={{ large: 2 }}>
        <Callout
          title={callout?.title}
          byline={callout?.byline}
          description={callout?.description}
          items={callout?.items as CalloutType['items']}
          imageFormat={callout?.imageFormat ?? 'square'}
        />
      </GridItem>
    ),
    CRCategories: () => (
      <GridItem span={{ medium: 8, large: 8 }} columnStart={{ medium: 3, large: 3 }}>
        <CRCategories categories={crSections} />
      </GridItem>
    ),
    TaxonomyConversionBanner: () => (
      <GridItem span={{ small: 'full-bleed', medium: 'full-bleed', large: 'full-bleed' }}>
        <TaxonomyConversionBanner {...taxonomyConversionBanner} />
      </GridItem>
    ),
    ConsumerRightsFooter: () => (
      <GridItem>
        <LocalFooter data={consumerRightsFooter} />
      </GridItem>
    ),
  }
}
